import React from 'react';
import ContactForm from '../components/ContactForm';

const GetInTouch: React.FC = () => {
  return (
    <div className="pt-48 pb-40 md:pt-48 md:pb-48">
      <div className="text-center mb-32">
        <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-4">
          <span className="text-white">Contact Our</span>
          <span className="block mt-4 bg-gradient-to-r from-primary to-[#E6C45C] text-transparent bg-clip-text">Developers</span>
        </h1>
      </div>
      <ContactForm />
      
      {/* Direct Email Section */}
      <div className="mt-32 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 font-montserrat">
          Or Email Us Directly
        </h2>
        <div className="relative inline-block overflow-hidden rounded-2xl bg-gradient-to-br from-primary via-[#E6C45C] to-primary group">
          {/* Shine Effect */}
          <div 
            className="absolute inset-0 transition-transform duration-1000 group-hover:translate-x-full"
            style={{
              backgroundImage: `linear-gradient(120deg, 
                rgba(255,255,255,0) 0%,
                rgba(255,255,255,0.2) 25%,
                rgba(255,255,255,0) 50%
              )`,
              backgroundSize: '200% 200%'
            }}
          />

          {/* Content */}
          <div className="relative px-6 sm:px-12 py-8">
            <div className="flex flex-col items-center gap-4">
              <a 
                href="mailto:mail@digitalmemorials.ie"
                className="inline-flex items-center justify-center group/link"
              >
                <span className="text-lg sm:text-xl md:text-2xl font-montserrat text-[#0A0A0A] group-hover/link:opacity-80 transition-all duration-300 break-all sm:break-normal">
                  mail@digitalmemorials.ie
                </span>
                <svg 
                  className="w-5 h-5 sm:w-6 sm:h-6 ml-2 transform translate-x-0 group-hover/link:translate-x-1 transition-transform duration-300" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </a>
              <p className="text-xs sm:text-sm text-[#0A0A0A]/60 font-montserrat">
                Click to open your email client
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch; 